import { Directive, ElementRef, Output } from '@angular/core';
import { fromEvent, map, Observable, switchMap, takeUntil } from 'rxjs';

@Directive({
    selector: '[appSplitHandle]'
})
export class SplitHandleDirective {

    @Output() drag: Observable<{ x: number, y: number }>;

    constructor(ref: ElementRef) {

        const getMouseEventPosition = (event: MouseEvent) => ({ x: event.movementX, y: event.movementY });

        const mousedown$ =
            fromEvent(ref.nativeElement, 'mousedown').pipe(map(getMouseEventPosition));
        const mousemove$ = fromEvent(document, 'mousemove').pipe(map(getMouseEventPosition));
        const mouseup$ = fromEvent(document, 'mouseup');

        this.drag = mousedown$.pipe(
            switchMap((mousedown: MouseEvent) =>
                mousemove$.pipe(map(mousemove => ({
                    x: mousemove.x - mousedown.x,
                    y: mousemove.y - mousedown.y
                }))
                    ,
                    takeUntil(mouseup$)
                )))
            ;
    }
}
